import { useEffect } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormButton from "../../components/FormButton";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { $api } from "../../helper";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { tokenMock } from "../../helper/mock";
import { useNavigate, useSearchParams } from "react-router";
import { useNotify } from "../../helper/notify";

export default function AddSocialMedia() {
  const { setDashboardName } = useStore(useDashboardName);
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const navigate = useNavigate();
  const { data } = $api.useQuery("get", "/site-api/v1/social-media-form/");
  const detail = $api.useMutation("get", "/site-api/v1/social-media-detail/");
  const sendData = $api.useMutation("post", "/site-api/v1/social-media/");
  const update = $api.useMutation("put", "/site-api/v1/social-media/");

  useEffect(() => {
    setDashboardName("افزودن شبکه اجتماعی");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            social_media_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (searchParams.get("u_id")) {
      form.setFieldValue("link", detail.data?.data.link);
      form.setFieldValue("name", detail.data?.data.name);
    }
  }, [detail.data]);

  const onFinish = (
    values: { name: number; link: string },
    redirect = true,
  ) => {
    if (!searchParams.get("u_id")) {
      sendData.mutate(
        {
          body: values,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/social-network-setting");
            } else {
              window.location.href = window.location.pathname;
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: {
            ...values,
            social_media_u_id: searchParams.get("u_id") ?? "",
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/social-network-setting");
            } else {
              window.location.href = window.location.pathname;
            }
          },
        },
      );
    }
  };
  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        title="اطلاعات شبکه اجتماعی"
        subTitle="تعریف و تنظیمات پایع مربوط به شبکه اجتماعی"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
          <FormItemInputSelect
            name={"name"}
            rules={requireRules("انتخاب شبکه اجتماعی")}
            label="شبکه اجتماعی"
            className="col-span-1"
            inputProps={{
              options: data?.data?.map((e) => ({
                label: (
                  <div className="flex gap-2.5 items-center">
                    <img
                      className="w-6 h-6"
                      src={GetFullMediaPath(e.image)}
                      alt=""
                    />
                    <span>{e.name}</span>
                  </div>
                ),
                value: e.number,
              })),
            }}
          />
          <FormItemInput
            name={"link"}
            rules={requireRules("لینک شبکه اجتماعی")}
            label="لینک شبکه اجتماعی"
            className="col-span-1"
          />
        </div>
      </FormCard>
      <FormButton
        isPending={sendData.isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
